import { ApolloClient, InMemoryCache } from '@apollo/client';
import gql from "graphql-tag";



export const login = async (email: string, password: string) => {
	
	const client = new ApolloClient({
		uri: 'http://localhost:4000/graphql',
		cache: new InMemoryCache(),
		headers: {
		  authorization: 'Apikey ',
		},
	});
	
  	const LOGIN = gql`
	 query ($email: String!, $password: String!){
		login(email: $email, password: $password) {
			token
			statusCode
			message
		} 
	}
	`;

	const results = await client.query({
		query: LOGIN,
		variables: { "email": email, "password": password },
	});

	const {data, loading, networkStatus} = results; 
	const token = data.login.token;
	let isAuthenticated = false
  
	if (token) {
		
		localStorage.setItem('user', JSON.stringify(data));
	}
    
	return isAuthenticated;
	
};

export const signup = async (firstName: string, lastName: string, email: string, password: string) => {
	const client = new ApolloClient({
		uri: 'http://localhost:4000/graphql',
		cache: new InMemoryCache(),
		headers: {
		  authorization: 'Apikey ',
		},
	});
 
	const SIGNUP = gql`
	    mutation ($firstName: String!, $lastName: String!, $email: String!, $password: String!) {
			signup (firstName: $firstName, lastName: $lastName, email: $email, password: $password){
				token
				statusCode
			}
		}
	`;
	const results = await client.mutate({
		mutation: SIGNUP,
		variables: { "firstName": firstName, "lastName": lastName, "email": email, "password": password },
	});
  
	
};

export const authenticated = () => {
	const user = localStorage.getItem('user');
	if (!user) {
		return null 
	}
	return JSON.parse(user);
};